import { createContext, FC, PropsWithChildren, useContext, useEffect, useState } from 'react';

type EmailNNotVerifiedCountContextType = {
  count: number;
  set: (count: number) => void;
};

const EmailNNotVerifiedCountContext = createContext<EmailNNotVerifiedCountContextType>({
  count: 0,
  set: () => { }
});

export const useMailNotVerifiedCountContext = () => useContext(EmailNNotVerifiedCountContext);

export const EmailNNotVerifiedCountProvider: FC<PropsWithChildren> = ({ children }) => {
  const [showEmailNotVerifiedCount, setShowEmailNotVerifiedCount] = useState<number>(
    +(localStorage.getItem('showEmailNotVerifiedCount') || '0')
  );

  useEffect(() => {
    localStorage.setItem('showEmailNotVerifiedCount', showEmailNotVerifiedCount.toString());
  }, [showEmailNotVerifiedCount]);

  return <EmailNNotVerifiedCountContext.Provider value={{
    count: showEmailNotVerifiedCount,
    set: setShowEmailNotVerifiedCount
  }}>
    {children}
  </EmailNNotVerifiedCountContext.Provider>;
};